  <!-- 
自定义验证码输入、密码输入使用
 
使用方法：
maxlength：输入最大长度
isPwd：是否是密码模式
@finish：回调函数
 <validcode :maxlength="4" :isPwd="false" @finish="finish"></validcode>
 -->
<template>
	<div id="app">
		<div class="captcha">
			<input v-for="(c, index) in ct" :key="index"
			type="text" v-model="ct[index]" ref="input" 
			:style="{borderBottomColor: index <= cIndex ? '#333' : ''}"
			@input="e => {onInput(e.target.value, index)}" 
			@keydown.delete="e=>{onKeydown(e.target.value, index)}"
			@focus="onFocus"
			:disabled="loading"
			>
		</div>
		<p>{{msg}}</p>
	</div>
</template>

<script>
export default {
	props: {
		//最大长度 值为4或者6
		maxlength: {
			type: Number,
			default: 4
		},
		focus: {
			type: Boolean,
			default: true
		},
		
		//是否是密码
		isPwd: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			ct: ['', '', '', ''],
			loading: false,
			msg: '',
		}
	},
	computed: {
    ctSize() {
      return this.ct.length;
    },
    cIndex() {
      let i = this.ct.findIndex(item => item === '');
      i = (i + this.ctSize) % this.ctSize;
      return i;
    },
    lastCode() {
      return this.ct[this.ctSize - 1];
    }
  },
  watch: {
    cIndex() {
      this.resetCaret();
    },
    lastCode(val) {
      if (val) {
        this.$refs.input[this.ctSize - 1].blur();
        this.sendCaptcha();
      }
    }
  },
  mounted() {
    this.resetCaret();
  },
	methods: {
		onInput(val, index) {
			this.msg = ''
			val = val.replace(/\s/g, '');
			if (index == this.ctSize - 1) {
				this.ct[this.ctSize - 1] = val[0];   // 最后一个码，只允许输入一个字符。
			} else if(val.length > 1) {
				let i = index;
				for (i = index; i < this.ctSize && i - index < val.length; i++) {
				this.ct[i] = val[i];
				}
				this.resetCaret();
			}
			this.$emit('finish',this.ct.join(''));
		},
		// 重置光标位置。
		resetCaret() {
			this.$refs.input[this.ctSize-1].focus();
		},
		onFocus() {
			// 监听 focus 事件，将光标重定位到“第一个空白符的位置”。
			let index = this.ct.findIndex(item => item === '');
			index = (index + this.ctSize) % this.ctSize;
			// console.log(this.$refs.input)
			this.$refs.input[index].focus();
		},
		onKeydown(val, index) {
			if (val === '') {
				// 删除上一个input里的值，并对其focus。
				if (index > 0) {
				this.ct[index - 1] = '';
				this.$refs.input[index - 1].focus();
				}
			}
			this.$emit('finish',this.ct.join(''));
		},
		sendCaptcha() {
			this.$emit('finish',this.ct.join(''));
		},

		reset() {
			// 重置。一般是验证码错误时触发。
			this.ct = this.ct.map(item => '');
			this.resetCaret();
		}
	}
};
</script>

<style lang="less">
.captcha {
  display: flex;
  width:420px;
  height:60px;
  justify-content: center;
  margin:0 auto;
  border-radius: 10px;
  border: 1px solid #CCCCCC;
  overflow: hidden;
  input {
	width: 25%;
	text-align: center;
	border: none;
	border-right: 1px solid #CCCCCC;
	font-size: 24px;
	outline: none;
	}
	input:last-of-type {
	margin-right: 0;
	}
	input:disabled {
	color: #000;
	background-color: #fff;
	}
	input:last-child{
		border:none;
	}
}

.msg {
  text-align: center;
}
</style>